import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';

import { ModalController } from '@ionic/angular';

import { NavigationService } from '@src/app/core/services/navigation/navigation.service';

import { ProductsService } from '@core/services/products/products.service';

import { ProductStatementComponent } from '@pages/product/product-statement/product-statement.component';

import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class StatementCommand extends BaseProductCommand {
  readonly type = 'statement';
  readonly title = 'Выписка';
  readonly icon = 'scheduler';
  readonly productType: ProductTypes[] = [
    ProductTypes.ACCOUNT,
    ProductTypes.CARD,
    ProductTypes.DEPOSIT,
    ProductTypes.SAVE_ACCOUNT,
    ProductTypes.METAL_ACCOUNT
  ];

  readonly isInfoAction = true;
  readonly settingsNames = undefined;

  get order(): number {
    return this.getContextualOrder(
      {
        [ProductTypes.ACCOUNT]: 30, // Счет: Выписка (3-й в списке "прочее")
        [ProductTypes.SAVE_ACCOUNT]: 30, // Накопительный счет: Выписка (3-й в списке "прочее")
        [ProductTypes.METAL_ACCOUNT]: 30, // Металлический счет: Выписка (3-й в списке "прочее")
        [ProductTypes.CARD]: 10, // Карты: Выписка (1-й в списке "прочее")
        [ProductTypes.CREDIT]: 50, // Кредит: Выписка (5-й в списке "прочее")
        [ProductTypes.DEPOSIT]: 30 // Вклад: Выписка (3-й в списке "прочее")
      },
      999
    );
  }

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private navigationService: NavigationService,
    private modalCtrl: ModalController,
    private productsService: ProductsService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    await this.navigationService.push(`product/${context.data.id}/statement`, { state: { product: context.data } });

    // this.router.navigate([`${this.router.url}/statement`])

    // const modal = await this.modalCtrl.create({
    //   component: ProductStatementComponent,
    //   handle: false,
    //   cssClass: 'modal-height-fix custom',
    //   initialBreakpoint: 1,
    //   componentProps: {
    //     subtitle: this.productsService.getProductInfoById(context.data.id),
    //     currency: this.productsService.getProductCurrencyById(context.data.id),
    //     _product: context.data
    //   }
    // });

    // await modal.present();
  }

  protected checkAdditionalAvailability(context: IProductCommandContext): Observable<boolean> | boolean {
    // Скрываем команду если установлен запрет на получение выписок
    const isHiddenExtract = this.toBoolean(context.data.hiddenExtract);

    if (isHiddenExtract) {
      return false;
    }

    return context.data.borrowerType !== '0';
  }

  /**
   * Преобразует значение в boolean
   */
  private toBoolean(value: unknown): boolean {
    if (typeof value === 'boolean') {
      return value;
    }
    if (typeof value === 'string') {
      const v = value.trim().toLowerCase();

      return v === 'true' || v === '1';
    }
    if (typeof value === 'number') {
      return value === 1;
    }

    return false;
  }
}
